import React from 'react';
import { Check } from 'lucide-react';
export function IncludesSection() {
  return <section className="w-full bg-gradient-to-b from-lavender-light/10 to-rose-light/10 py-20 px-6 md:px-8 pt-[50px] pb-[50px]" data-id="element-178">
      <div className="max-w-4xl mx-auto" data-id="element-179">
        <h2 className="text-3xl md:text-4xl font-bold text-text text-center mb-12" data-id="element-180">
          ¿Qué incluye exactamente?
        </h2>

        <div className="space-y-4 mb-8" data-id="element-181">
          {[{
          title: 'Guión diario Semana 1 (Días 1–7):',
          subtitle: 'No pensar, solo seguir'
        }, {
          title: 'Guión Semana 2 (Días 8–14):',
          subtitle: 'Estabilizar sin exigirte'
        }, {
          title: 'Guión Semana 3 (Días 15–21):',
          subtitle: 'Recuperar control a tu ritmo'
        }, {
          title: 'Guión Semana 4 (Días 22–30):',
          subtitle: 'Construir tu sistema personal'
        }, {
          title: '3 Micro-Rutinas (Mente / Cuerpo / Casa):',
          subtitle: '5 a 10 min, accionables desde hoy'
        }, {
          title: 'Scripts anti-culpa listos para usar',
          subtitle: null
        }, {
          title: 'Mensajes para pedir ayuda (copiar y pegar)',
          subtitle: null
        }, {
          title: 'Guiones de emergencia',
          subtitle: '(para cuando todo se cae)'
        }, {
          title: 'Plan de Mantenimiento 2×2 (Días 31–90):',
          subtitle: 'Para que no colapses después del mes 1'
        }, {
          title: 'Tus frases de acompañamiento:',
          subtitle: 'Tu ancla en los días más difíciles'
        }, {
          title: 'Semáforo de alertas médicas:',
          subtitle: 'Verde / Amarillo / Rojo'
        }].map((item, idx) => <div key={idx} className="flex items-start gap-4 p-5 rounded-xl bg-white/80 backdrop-blur-sm border border-lavender/20 shadow-sm hover:shadow-md transition-shadow pl-[10px] pr-[10px] pt-[10px] pb-[10px]" data-id="element-182">
              <div className="mt-1 w-6 h-6 rounded-full bg-lavender flex items-center justify-center flex-shrink-0" data-id="element-183">
                <Check className="w-4 h-4 text-white" data-id="element-184" />
              </div>
              <div data-id="element-185">
                <span className="font-semibold text-text block pl-[5px] pr-[5px] text-[22px]" data-id="element-186">
                  {item.title}
                </span>
                {item.subtitle && <span className="text-text-light block mt-1 text-[18px]" data-id="element-187">
                    {item.subtitle}
                  </span>}
              </div>
            </div>)}
        </div>

        {/* Note below list */}
        <div className="rounded-2xl p-6 md:p-8 border border-lavender/20 bg-[#F5EBE0] pt-[7px] pb-[7px]" data-id="element-188">
          <p className="text-base md:text-lg text-text/80 leading-relaxed italic text-center" data-id="element-189">
            Todo esto en un PDF listo para abrir a las 3 a.m., con una sola
            mano. Plantillas con checkboxes, para marcar y seguir, ya sea en el
            celular o impreso.
          </p>
        </div>
      </div>
    </section>;
}